import { numberMoney } from 'Data/format.js'

export function getRemainingMaxDiscount(max_discount, treatment_discounts) {
  return max_discount ? numberMoney(max_discount - treatment_discounts) : '-'
}
